import Tournaments from "./Tournaments";

const TournamentsContainer: React.FC = () => {
  return <Tournaments />;
};

export default TournamentsContainer;
